<template>
  <div class="autorizacao">
    <div>
      <v-btn icon to="/cancelamento-diario">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert type="error" :value="true" color="error" class="mt-4">
      <div>ATENÇÃO: Ao autorizar o professor no cancelamento do diário você está dando poder para ele <STRONG>EXCLUIR</STRONG> suas aulas com respectivas frequências, bem como notas e conceitos, conforme período avaliativo autorizado.</div>
    </v-alert>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3 mt-3">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card class="pa-3 mt-3">
      <form @submit.prevent="onSubmit">
        <Select label="Ano letivo*" v-model="form.aaletivo" :options="optionsAnos" :v="$v.form.aaletivo" :disabled="isStateDisabled" @change="changeAno"/>
        <Select :label="`Nível Ensino* (${ optionsNivelEnsino.length == 0 ?  optionsNivelEnsino.length : optionsNivelEnsino.length - 1 })`" v-model="form.cdinstruc" :options="optionsNivelEnsino" :v="$v.form.cdinstruc" :disabled="isStateDisabled" @change="changeNivelDeEnsino"/>
        <Select :label="`Período Avaliativo* (${ optionsPeriodo.length == 0 ?  optionsPeriodo.length : optionsPeriodo.length - 1 })`" :options="optionsPeriodo" v-model="form.cdpravadi" :v="$v.form.cdpravadi" :disabled="isStateDisabled" @change="changePeriodoAvaliativo"/>
        <Select :label="`Etapa Escola* (${ optionsEtapaEscolar.length == 0 ?  optionsEtapaEscolar.length : optionsEtapaEscolar.length - 1 })`" v-model="form.cdserie" :options="optionsEtapaEscolar" :v="$v.form.cdserie" :disabled="isStateDisabled" @change="changeEtapaEscolar"/>
        <Select :label="`Escola* (${ optionsEscola.length == 0 ?  optionsEscola.length : optionsEscola.length - 1 })`" v-model="escolaSelected" :options="optionsEscola" :v="$v.form.cdescola" :disabled="isStateDisabled" @change="changeEscola"/>
        <Select :label="`Professor* (${ optionsProfessor.length == 0 ?  optionsProfessor.length : optionsProfessor.length - 1 })`" v-model="professorSelected" :options="optionsProfessor" :v="$v.form.cdmatric" :disabled="isStateDisabled" @change="changeProfessor"/>
        <Select :label="`Turma* (${ optionsTurma.length == 0 ?  optionsTurma.length : optionsTurma.length - 1 })`" :options="optionsTurma" v-model="form.cdturma" :v="$v.form.cdturma" :disabled="isStateDisabled" @change="changeTurma"/>
        <Select :label="`Disciplina* (${ optionsDisciplina.length == 0 ?  optionsDisciplina.length : optionsDisciplina.length - 1 })`" :options="optionsDisciplina" v-model.number="form.cddiscipl" :v="$v.form.cddiscipl" :disabled="isStateDisabled"/>
        <Input type="date" label="Data de Abertura" v-model="form.dataaberturacancelamento" :v="$v.form.dataaberturacancelamento" :disabled="isStateDisabled"/>
        <Input class="mt-4" type="date" label="Data de Fechamento" v-model="form.datafechamentocancelamento" :v="$v.form.datafechamentocancelamento" :disabled="isStateDisabled"/>
        <TextArea label="Observação" v-model="form.descricaoobservacao" :v="$v.form.descricaoobservacao" :disabled="loading"/>
        <div class="mt-3" style="text-align: right">
          <v-btn type="submit" :loading="loading" small dark color="teal" class="rounded-sm font-weight-regular" width="90px">Salvar</v-btn>
        </div>
      </form>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
      <div class="d-flex justify-space-between align-center">
        <span> {{ submitText }}</span>
        <v-btn class="text-right" variant="text" icon @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, maxLength, integer } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

import api from '@/api'

const TurmasRepository = RepositoryFactory.get('turma');
const DisciplinaRepository = RepositoryFactory.get('disciplina');
const CancelamentoDiarioRepository = RepositoryFactory.get('cancelamentoDiario');

const setFormInicial = (props) => ({
  aaletivo: '',
  cdinstruc: '',
  cdserie: '',
  cdtipesc: '',
  cdescola: '',
  cdpessoal: '',
  cdmatric: '',
  cdturma: '',
  cddiscipl: '',
  cdpravadi: '',
  dataaberturacancelamento: '',
  datafechamentocancelamento: '',
  descricaoobservacao: '',
});

const defaultSelect = () => ({
  text: '',
  value: '',
});

export default {
  name: 'CancelamentoDiarioCadastro',

  props: {
    id: [Number, String],
  },
  data() {
    return {
      form: setFormInicial(),
      loading: false,
      msgArrayError: [],
      submitText: '',
      snackbar: false,
      optionsNivelEnsino: [],
      optionsEtapaEscolar: [],
      optionsEscola: [],
      optionsProfessor: [],
      optionsTurma: [],
      optionsDisciplina: [],
      optionsPeriodo: [],
      professorSelected: '',
      escolaSelected: '',
    };
  },
  validations: {
    form: {
      aaletivo: { required, integer },
      cdinstruc: { required, integer },
      cdpravadi: { required },
      cdserie: { required, integer },
      cdtipesc: { required, integer },
      cdescola: { required, integer },
      cdpessoal: { required, integer },
      cdmatric: { required, integer },
      cdturma: { required, maxLength: maxLength(4) },
      cddiscipl: { required, integer },
      dataaberturacancelamento: { required },
      datafechamentocancelamento: { required },
      descricaoobservacao: { maxLength: maxLength(400) },
    },
  },
  async beforeRouteEnter(to, from, next) {
    try{
      let editar = {};
      if(to.params.id) {
        editar = await CancelamentoDiarioRepository.getCancelamento(to.params.id);
      }
      next(vm => {
        if(to.params.id) {
          vm.load(editar.data.results);
        } else {
          vm.changeAno();
        }
      });
    }
    catch(e){
      next('/cancelamento-diario');
    }
  },
  created(){
    this.$Progress.finish();
  },
  methods: {
    async load(data) {
      this.loading = true;
      this.form = { ...data };

      this.professorSelected = JSON.stringify({ cdpessoal: parseInt(data.cdpessoal), cdmatric: parseInt(data.cdmatric) });
      this.escolaSelected = JSON.stringify({ cdtipesc: parseInt(data.cdtipesc), cdescola: parseInt(data.cdescola) });

      this.optionsNivelEnsino = [{ value: data.nivel.cdinstruc, text: data.nivel.dsinstruc }];
      this.optionsNivelEnsino.unshift({ value: '{}', text: '' });

      this.optionsPeriodo = [{ value: data.periodo_avaliativo.cdpravadi, text: data.periodo_avaliativo.dspravadi }];
      this.optionsPeriodo.unshift({ value: '{}', text: '' });

      this.optionsEtapaEscolar = [{ value: data.etapa_escolar.cdserie, text: data.etapa_escolar.dsserie }];
      this.optionsEtapaEscolar.unshift({ value: '{}', text: '' });

      this.optionsEscola = [{ value: JSON.stringify({ cdtipesc: parseInt(data.escola.cdtipesc), cdescola: parseInt(data.escola.cdescola) }), text: data.escola.nmescola }];
      this.optionsEscola.unshift({ value: '{}', text: '' });


      this.optionsProfessor = [{ value: JSON.stringify({ cdpessoal: parseInt(data.professor.cdpessoal), cdmatric: parseInt(data.professor.cdmatric) }), text: data.professor.nmfuncion }];
      this.optionsProfessor.unshift({ value: '{}', text: '' });

      this.optionsTurma = [{ value: data.turma.cdturma, text: data.turma.nmturma }];
      this.optionsTurma.unshift({ value: '{}', text: '' });

      this.optionsDisciplina = [{ value: data.disciplina.cddiscipl, text: data.disciplina.dsdiscipl }];
      this.optionsDisciplina.unshift({ value: '{}', text: '' });

      this.loading = false;
    },
    async changeAno() {
      if(!this.form.aaletivo) {
        this.form.aaletivo = new Date().getFullYear();
      }
      this.form.cdinstruc = '';
      this.form.cdserie = '';
      this.form.cdtipesc = '';
      this.form.cdescola = '';
      this.form.cdturma = '';
      this.form.cddiscipl = '';
      this.form.cdpravadi = '';
      this.form.cdpessoal = '';
      this.form.cdmatric = '';
      this.professorSelected = '';
      this.escolaSelected = '';
      this.optionsNivelEnsino = [];
      this.optionsPeriodo = [];
      this.optionsEtapaEscolar = [];
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
      await this.loadNivelDeEnsino();
    },
    async changeNivelDeEnsino() {
      this.form.cdserie = '';
      this.form.cdtipesc = '';
      this.form.cdescola = '';
      this.form.cdturma = '';
      this.form.cddiscipl = '';
      this.form.cdpravadi = '';
      this.form.cdpessoal = '';
      this.form.cdmatric = '';
      this.professorSelected = '';
      this.escolaSelected = '';
      this.optionsPeriodo = [];
      this.optionsEtapaEscolar = [];
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
      await this.loadPeriodoAvaliativo();

    },
    async changePeriodoAvaliativo() {
      this.form.cdserie = '';
      this.form.cdtipesc = '';
      this.form.cdescola = '';
      this.form.cdturma = '';
      this.form.cddiscipl = '';
      this.form.cdpessoal = '';
      this.form.cdmatric = '';
      this.professorSelected = '';
      this.escolaSelected = '';
      this.optionsEtapaEscolar = [];
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
      await this.loadEtapaEscolar();
    },
    async changeEtapaEscolar() {
      this.form.cdtipesc = '';
      this.form.cdescola = '';
      this.form.cdturma = '';
      this.form.cddiscipl = '';
      this.form.cdpessoal = '';
      this.form.cdmatric = '';
      this.professorSelected = '';
      this.escolaSelected = '';
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
      await this.loadEscola();
    },
    async changeEscola() {
      this.form.cdturma = '';
      this.form.cddiscipl = '';
      this.form.cdpessoal = '';
      this.form.cdmatric = '';
      this.professorSelected = '';
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];

      const dados = JSON.parse(this.escolaSelected);
      if(typeof dados.cdtipesc !== 'undefined' && typeof dados.cdescola !== 'undefined') {
        this.form.cdtipesc = dados.cdtipesc;
        this.form.cdescola = dados.cdescola;
      }

      await this.loadProfessor();
    },
    async changeProfessor() {
      this.form.cdturma = '';
      this.form.cddiscipl = '';
      this.optionsTurma = [];
      this.optionsDisciplina = [];

      const dados = JSON.parse(this.professorSelected);
      if(typeof dados.cdpessoal !== 'undefined' && typeof dados.cdmatric !== 'undefined') {
        this.form.cdpessoal = dados.cdpessoal;
        this.form.cdmatric = dados.cdmatric;
      }

      await this.loadTurma();
    },
    async changeTurma() {
      this.form.cddiscipl = '';
      this.optionsDisciplina = [];
      await this.loadDisciplinaPeriodo();
    },
    async loadEscola() {
      try{
        this.loading = true;

        const params = {
          aaletivo: this.form.aaletivo,
          cdinstruc: this.form.cdinstruc,
          cdserie: this.form.cdserie,
          cdpravadi: this.form.cdpravadi
        };

        const { data } = await api.get('ei/escola/getEscolaPorNivelDeEnsino', { params });

        this.optionsEscola = data.results.map(key => ({ value: JSON.stringify({ cdtipesc: parseInt(key.cdtipesc), cdescola: parseInt(key.cdescola) }), text: key.nmescola }));
        this.optionsEscola.unshift({ value: '{}', text: '' });
      } finally {
        this.loading = false;
      }
    },
    async loadPeriodoAvaliativo() {
      try{
        this.loading = true;

        const params = {
          aaletivo: this.form.aaletivo,
          cdinstruc: this.form.cdinstruc
        };

        const { data } = await api.get('ei/periodo-avaliativo/getPeriodoAvaliativoPorNivelDeEnsino', { params });

        this.optionsPeriodo = data.results.map(key => ({ value: key.cdpravadi, text: `${key.dspravadi}` }));
        this.optionsPeriodo.unshift({ value: '{}', text: '' });
      } finally {
        this.loading = false;
      }
    },
    async loadEtapaEscolar() {
      try{
        this.loading = true;

        const params = {
          aaletivo: this.form.aaletivo,
          cdinstruc: this.form.cdinstruc,
          cdpravadi: this.form.cdpravadi
        };

        const { data } = await api.get('ei/etapaescolar/getEtapaEscolarPorNivelDeEnsino', { params });

        this.optionsEtapaEscolar = data.results.map(key => ({ value: key.cdserie, text: `${key.dsserie}` }));
        this.optionsEtapaEscolar.unshift({ value: '{}', text: '' });
      } finally {
        this.loading = false;
      }
    },
    async loadNivelDeEnsino() {
      try{
        this.loading = true;
        const { data } = await api.get(`ei/nivelensino/${this.form.aaletivo}`)

        this.optionsNivelEnsino = data.results.map(key => ({ value: key.cdinstruc, text: `${key.cdinstruc} - ${key.dsinstruc}` }));
        this.optionsNivelEnsino.unshift({ value: '{}', text: '' });
      } finally {
        this.loading = false;
      }
    },
    async loadProfessor() {
      try{
        this.loading = true;

        const params = {
          aaletivo: this.form.aaletivo,
          cdinstruc: this.form.cdinstruc,
          cdserie: this.form.cdserie,
          cdtipesc: this.form.cdtipesc,
          cdescola: this.form.cdescola,
          cdpravadi: this.form.cdpravadi
        };

        const { data } = await api.get('ei/professor/getProfessorPorNivelDeEnsinoEtapaEscolarEhEscola', { params });

        this.optionsProfessor = data.results.map(key => ({ value: JSON.stringify({ cdpessoal: parseInt(key.cdpessoal), cdmatric: parseInt(key.cdmatric) }), text: key.nmfuncion }));
        this.optionsProfessor.unshift({ value: '{}', text: '' });
      } finally {
        this.loading = false;
      }
    },
    async loadTurma() {
      try{
        this.loading = true;
        const { data } = await TurmasRepository.getSelectTurmasProfessor({
          cdtipesc: this.form.cdtipesc,
          cdescola: this.form.cdescola,
          cdpessoal: this.form.cdpessoal,
          cdmatric: this.form.cdmatric,
          aaletivo: this.form.aaletivo,
        });

        this.optionsTurma = data.results.map(key => ({ text: `${key.nmturma} - ${key.horario}`, value: key.cdturma }));
        this.optionsTurma.unshift(defaultSelect());
      } finally {
        this.loading = false;
      }
    },
    async loadDisciplinaPeriodo() {
      try {
        this.loading = true;
        const { data } = await DisciplinaRepository.getSelectDisciplinaProfessorPeriodo({
          cdtipesc: this.form.cdtipesc,
          cdescola: this.form.cdescola,
          cdpessoal: this.form.cdpessoal,
          cdmatric: this.form.cdmatric,
          aaletivo: this.aaletivo,
          cdturma: this.form.cdturma,
          aaletivo: this.form.aaletivo,
        })

        this.optionsDisciplina = data.results.disciplinas.map(key => ({ text: key.dsdiscipl, value: key.cddiscipl }));
        this.optionsDisciplina.unshift(defaultSelect());
      } finally {
        this.loading = false;
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        this.msgArrayError = [];
        const funcao = (this.id) ? 'put' : 'post';
        const { data } = await CancelamentoDiarioRepository[`${funcao}Cancelamento`](this.form);

        this.submitText = data.message;
        this.snackbar = true;

        setTimeout(() => {
          this.$root.$router.push({
            path: '/cancelamento-diario',
          });
        }, 1000);
      } catch(error) {
        if (error.response && error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        else if (error.response) { this.msgArrayError = ['Houve um erro.']}
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters(['getAnoAtualServidor', 'getAnoInicioSistema']), optionsAnos() {

      const anosAtivos = []
      for(let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        anosAtivos.push({ text: i, value: i });
      }

      return [ defaultSelect(), ...anosAtivos ];
    },
    isStateDisabled() {
      return this.loading || this.form.identificadorautorizacaocancelamentodiario
    }
  },
}
</script>

<style lang="scss">
.autorizacao {
  margin: 0px 15px;
}
</style>
